import React from 'react'

export default function Jumbotron(props){
    return (
        <div style={{padding: "2rem 1rem", marginBottom: "2rem", borderRadius: ".3rem"}} className="bg-light p-5 rounded-lg">
            {props.children}
        </div>
    )
}